const MAX_SAMPLE_LIMIT = 2;

window.addEventListener('DOMContentLoaded', function () {
  (function ($) {
    const vpvCart = {
      lineItemNodes: document.querySelectorAll('.cart-item'),
      sampleSliderNode: document.querySelector('.free-samples__slider'),
      sampleNodes: document.querySelectorAll('.sample-card'),
      samplesInCart: [],
    };

    if (!window.__VPV) {
      window.__VPV = { cart: vpvCart };
    } else {
      window.__VPV.cart = vpvCart;
    }

    if (document.querySelector('.free-samples')) {


      $(document).on('cart.requestStarted', function (event, cart) {
        // Add request loading class
        document.querySelector('.free-samples').classList.add('free-samples--request');
      });

      $(document).on('cart.ready cart.requestComplete', function (event, cart) {
        console.log('--- vpv-cart.js - cart.ready cart.requestComplete ---');
        if (cart.item_count == 0) {
          window.location.reload();
        } else {
          const non_sample_lines = cart.items.filter(item => item.product_type != 'Sample').length;
          if (non_sample_lines == 0) {
            // Remove all items
            $.post('/cart/clear.js', function() {
              window.location.reload();
            });
          }
        }
        
        checkCartSamples(cart, updateSamples);
        checkApplySamples(cart)
      });

      const targetNode = document.querySelector('.cart-list');
      const config = { childList: true, subtree: true };
      const observer = new MutationObserver(function () {
        updateCartSamples()
      });
      observer.observe(targetNode, config);
  

      document.addEventListener('resize', function () {
        clearTimeout(restTimer)
        const restTimer = setTimeout(function () {
          initSlider();
        }, 500);
      });

      initSampleClicks(window.__VPV.cart.sampleNodes);
      initSlider();

    }

    function checkApplySamples(cart) {
      if (!cart.item_count || cart.total_price === 0 || cart.item_count === window.__VPV.cart.samplesInCart.length) {
        window.__VPV.cart.samplesInCart.forEach(sampleId => {
          CartJS.removeItemById(sampleId);
        })
        document.querySelector('.free-samples').classList.add('free-samples--disable');
      } else {
        document.querySelector('.free-samples').classList.remove('free-samples--disable');
      }
    }

    function checkCartSamples(cart, updateSamples) {
      // Ensures no sample has more than one in quantity before updating samples
      const { samplesInCart } = window.__VPV.cart;
      const updateObject = {};
      const n = cart.items.length;
      for (let i = 0; i < n; i++) {
        const cartItem = cart.items[i];
        if (cartItem.quantity > 1 && samplesInCart.includes(cartItem.id)) {
          updateObject[cartItem.id] = 1
        }
      }
      if (Object.keys(updateObject).length) {
        CartJS.updateItemQuantitiesById(updateObject);
      } else {
        updateSamples(cart);
      }
    }

    function updateCartSamples() {
      // Disables increment button on sample line items
      const { samplesInCart } = window.__VPV.cart;

      // Last sample product
      const product = window.items[window.items.length - 1]
      document.querySelectorAll('.cart-item').forEach((lineItem) => {
        const lineItemId = parseInt(lineItem.getAttribute('data-cart-item').split(':')[0]);
        const incrementBtn = lineItem.querySelector('.cart-item-quantity .adjust-plus');
        const itemTitle = lineItem.querySelector('.cart-item-title');
        const subTitleFreeCard = itemTitle.querySelector('.free-card');
        const subTitleProperty = itemTitle.querySelector('.property');

        if (incrementBtn && (samplesInCart.includes(lineItemId))) {
          incrementBtn.setAttribute('disabled', 'disabled');
        } else if (incrementBtn) {
          incrementBtn.removeAttribute('disabled');
        }

        if (samplesInCart.includes(lineItemId)) {
          if (subTitleProperty === null) {
            const newSubtitle = document.createElement('span');
            newSubtitle.innerHTML = 'Limit 1 per person';
            itemTitle.appendChild(newSubtitle);
            newSubtitle.classList.remove('variant');
            newSubtitle.classList.add('property');
          }
          if (subTitleFreeCard) {
            itemTitle.removeChild(subTitleFreeCard);
          }
        }
      })
    }

    function updateSamples(cart) {
      const { sampleNodes } = window.__VPV.cart;
      const container = document.querySelector('.free-samples');
      const cartIds = cart.items.map(item => item.id);

      // Update selected sample cards
      const samplesInCart = [];
      const n = sampleNodes.length;
      for (let i = 0; i < n; i++) {
        const sample = sampleNodes[i];
        const sampleId = parseInt(sample.getAttribute('data-variant-id'));
        const inCart = cartIds.includes(sampleId);

        if (inCart) {
          samplesInCart.push(sampleId);
          sample.classList.add('sample-card--selected');
        } else {
          sample.classList.remove('sample-card--selected');
        }
      }

      // Hide/Show limit reached message
      if (samplesInCart.length >= MAX_SAMPLE_LIMIT) {
        container.classList.add('free-samples--limit');
      } else {
        container.classList.remove('free-samples--limit');
      }

      // Remove request loading class
      container.classList.remove('free-samples--request');

      // Store added samples for use by
      window.__VPV.cart.samplesInCart = samplesInCart;

      updateCartSamples();
    }

    function initSlider() {
      // Reinitializes slider to ensure responsive style
      const { sampleSliderNode } = window.__VPV.cart;

      // If Checkout is not empty
      if (sampleSliderNode) {

        const isDesktop = window.matchMedia('(min-width: 800px)').matches;

        if (window.__VPV.cart.sampleSlider) {
          window.__VPV.cart.sampleSlider.destroy();
        }

        window.__VPV.cart.sampleSlider = new Flickity(sampleSliderNode, {
          groupCells: isDesktop ? 3 : 2,
          cellAlign: 'left',
          pageDots: false,
          draggable: true,
          freeScroll: true,
          wrapAround: true
        });
        sampleSliderNode.classList.remove('free-samples__slider--loading');
      }

    }

    function initSampleClicks(sampleNodes) {
      // Adds click listeners to Sample Cards
      const n = sampleNodes.length;
      for (let i = 0; i < n; i++) {
        const sampleNode = sampleNodes[i];
        var handler = function (e) {
          const sample = e.target;
          const sampleId = parseInt(sample.getAttribute('data-variant-id'));
          if (sample.classList.contains('sample-card--selected')) {
            CartJS.removeItemById(sampleId).then( function(res) {
              const product = window.freeSamples.find( item => item.variants[0].id === parseInt(sampleId));
              if (window.__VPV.pushAtcDataLayer) {
                window.__VPV.pushAtcDataLayerRemove({ product, quantity: 1 });
              } 
            })
          } else if (window.__VPV.cart.samplesInCart.length < MAX_SAMPLE_LIMIT) {
            CartJS.addItem(sampleId, 1)
            const product = window.freeSamples.find( item => item.variants[0].id === parseInt(sampleId));
            if (window.__VPV.pushAtcDataLayer) {
              window.__VPV.pushAtcDataLayerForm({ productData: product, isJSON: true, quantity: 1 });
            }
            product.id = product.variants[0].id;
            window.items.push(product)
          }
        };
        sampleNode.addEventListener('click', handler);
        sampleNode.addEventListener('focus', function() {
          sampleNode.addEventListener('keydown', function(event) {
              if (event.key === ' ') {
                  handler(event);
              }
          });
      });
      }
    }

  })(jQuery);
});